export default "__VITE_ASSET__BBCDiRsA__"